import { useState, useEffect, useRef } from 'react'
import { AnimatePresence, motion, type Variants, type Transition } from 'framer-motion'

const timeLabelVariants: Variants = {
  initial: { opacity: 0, scale: 0.9, filter: 'blur(4px)' },
  animate: { opacity: 1, scale: 1, filter: 'blur(0px)' },
  exit: { opacity: 0, scale: 0.9, filter: 'blur(4px)' },
}

const timeLabelTransition: Transition = {
  type: 'spring',
  duration: 0.35,
  bounce: 0,
}

export function AnimatedTimeLabel({ text, animateInitial = true }: { text: string; animateInitial?: boolean }) {
  const [displayText, setDisplayText] = useState(text)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setDisplayText(text), 150)
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [text])

  return (
    <span className="inline-block whitespace-nowrap">
      <AnimatePresence mode="popLayout" initial={animateInitial}>
        <motion.span
          key={displayText}
          variants={timeLabelVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={timeLabelTransition}
          className="inline-block whitespace-nowrap"
        >
          {displayText}
        </motion.span>
      </AnimatePresence>
    </span>
  )
}
